module.exports = __webpack_public_path__ + "img/fb110a7.jpg";